type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};
const FunnelIcon = (props: Props) => {
  const { width = '20', height = '20', strokeColor = '#F3E9D7' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
      <path
        d="M3.75 5.625L8.75 11.875V15.625L11.25 16.875V11.875L16.25 5.625V3.125H3.75V5.625Z"
        stroke={strokeColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default FunnelIcon;
